export default class StringUtils {
  static RemoveSpaceFromString(value: string) {
    return value.replace(/ /gm, '');
  }

  static PascalToSnackCase(value: string) {
    return value
      .replace(/\s/g, '')
      .replace(/(?:^|\.?)([A-Z])/g, (_, y) => `-${y.toLowerCase()}`)
      .replace(/^_/, '');
  }

  static ConvertTitleCase(value: string) {
    return value.replace(
      /\w\S*/g,
      txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(),
    );
  }

  static RemoveSpaceToLowerCase(value: string) {
    return this.RemoveSpaceFromString(value).toLowerCase();
  }

  static StartWithVowel(word: string) {
    const vowelRegex = /^[aeiou]/i;
    return word.match(vowelRegex);
  }

  static RemoveTrailingPeriod(value: string) {
    return value[value.length - 1] === '.' ? value.slice(0, -1) : value;
  }

  static FilterLetters(value: string) {
    const lettersRegex = /[a-zA-Z0-9]+/g;
    return (value.match(lettersRegex) || []).join('');
  }

  static isEmptyString(text: string) {
    const trimmedString = text.trim();
    return (
      trimmedString === '' ||
      trimmedString === '>' ||
      trimmedString === '``````' ||
      trimmedString === '``' ||
      trimmedString === '**' ||
      trimmedString === '____' ||
      trimmedString === '__' ||
      trimmedString === '****'
    );
  }
}
